<template>
  <div class="guide-page-werp">
    <div class="guide-page-container" :style="'left:'+(-currentIndex*100)+'vw;'">
      <div v-for="(item, index) in pageController" :key="index" class="guide-page">
        <div class="guide-page-logo">
          <img src="@/assets/imgs/icon_logo.png" alt="">
        </div>
        <div class="guide-page-title">{{ item.title }}</div>
        <div class="guide-page-tips">{{ item.tips }}</div>
        <div class="guide-page-img">
          <img :src="item.img" alt="">
        </div>
        <div class="guide-page-btns">
          <div class="guide-page-btn" @click="onNext">{{ i18n.next }}</div>
        </div>
      </div>
    </div>
    <div class="guide-page-skip" @click="onSkip">{{ i18n.skip }}</div>
    <div class="guide-page-step-container">
      <div v-for="(item, index) in pageController" :key="index" class="guide-page-step" :class="{'guide-page-step-active': index === currentIndex}"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  computed: {
    ...mapState(["qrcode"]),
    i18n() {
      return this.$t("guide_page")
    },
    pageController () {
      return [
        {
          title: this.i18n.title1,
          tips: this.i18n.tips1,
          img: require('@/assets/imgs/guide/img_guide1.png')
        },
        {
          title: this.i18n.title2,
          tips: this.i18n.tips2,
          img: require('@/assets/imgs/guide/img_guide2.png')
        },
        {
          title: this.i18n.title3,
          tips: this.i18n.tips3,
          img: require('@/assets/imgs/guide/img_guide3.png')
        },
        {
          title: this.i18n.title4,
          tips: this.i18n.tips4,
          img: require('@/assets/imgs/guide/img_guide4.png')
        }
      ]
    }
  },
  data() {
    return {
      currentIndex: 0
    }
  },
  methods: {
    onNext () {
      if (this.currentIndex < 3) {
        this.currentIndex++
      } else {
        this.onSkip()
      }
    },
    onSkip () {
      if (this.qrcode) {
        this.$router.push(`/?qrcode=${this.qrcode}`)
      } else {
        this.$router.push("/")
      }
    }
  }
}
</script>

<style lang="less" scoped>
.guide-page-werp {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #FFCA0E;
  position: relative;
  .guide-page-container {
    width: 400vw;
    height: 100vh;
    background: #FFCA0E;
    display: flex;
    position: absolute;
    top: 0;
    transition: transform 0.3s ease;
  }
  .guide-page {
    width: 100vw;
    height: 100vh;
    background: #FFCA0E;
    display: flex;
    flex-direction: column;
    color: #fff;
    .guide-page-logo {
      width: 116px;
      height: 116px;
      padding: 40px;
      margin: 0 auto;
      img {
        width: 116px;
        height: 116px;
      }
    }
    .guide-page-title {
      font-size: 46px;
      font-weight: bold;
      padding: 16px;
      text-align: center;
    }
    .guide-page-tips {
      height: 200px;
      padding: 0 56px;
      font-size: 28px;
      text-align: center;
    }
    .guide-page-img {
      flex: 1;
      width: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .guide-page-btns {
      padding: 102px;
      .guide-page-btn {
        width: 196px;
        height: 88px;
        margin: 0 auto;
        border-radius: 28px;
        line-height: 88px;
        text-align: center;
        background-color: #fff;
        color: #FFCA0E;
        font-size: 32px;
      }
    }
  }
  .guide-page-skip {
    position: absolute;
    top: 77px;
    right: 70px;
    color: #fff;
    font-size: 26px;
  }
  .guide-page-step-container {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 240px;
    display: flex;
    justify-content: center;
    .guide-page-step {
      width: 21px;
      height: 9px;
      border-radius: 5px;
      background: rgba(255, 255, 255, 0.7);
      margin: 0 10px;
    }
    .guide-page-step-active {
      width: 56px;
      background: #fff;
    }
  }
}
</style>
